export default __webpack_public_path__ + "static/media/Ntorq125Racing_Frente.12b6ad17.webp";